import { Avatar, Box, Button, Card, CardBody, CardHeader, DarkMode, Flex, Grid, Icon, Image, Text, useColorMode, useColorModeValue } from '@chakra-ui/react'
import React from 'react'
import { MdSettings } from 'react-icons/md'
import { ImProfile } from 'react-icons/im'
import { useStateContext } from '../../context/ContextProvider'
import {  useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
function Profile() {
    const { user } = useStateContext();
    const navigate = useNavigate()
    const { t } = useTranslation();

    return (
        <Box>
            <Flex direction='column' mt={{ sm: '25px', md: '0px' }}>
                <Flex
                    mb={{ base: "20px", sm: '24px', md: '50px', xl: '10px' }}
                    borderRadius='15px'
                    px='0px'
                    display='flex'
                    flexDirection='column'
                    justifyContent='center'
                    align='center'>
                    {/* Header */}
                    <Flex

                        direction={{ base: "column", sm: 'column', md: 'row' }}
                        mx='auto'
                        maxH='330px'
                        w={{ sm: '90%', xl: '100%' }}
                        justifyContent={{ sm: 'center', md: 'space-between' }}
                        align='center'
                        p='24px'
                        borderRadius='20px'
                        mt='10px'>
                        <Flex
                            align='center'
                            mb={{ sm: '10px', md: '10px' }}
                            direction={{ sm: 'column', md: 'row' }}
                            w={{ sm: '100%' }}
                            textAlign={{ sm: 'center', md: 'start' }}>
                            <Avatar me={{ md: '22px' }} mr={{ base: 5, sm: 0, md: 5 }} src={user?.image} w={{ base: "70px", md: "80px" }} h={{ base: "70px", md: "80px" }} borderRadius='15px'>
                                
                            </Avatar>
                            <Flex direction='column' maxWidth='100%' my={{ sm: '14px' }}>
                                <Flex direction='row' align={'center'}>
                                <Text
                                    fontSize={{ sm: 'lg', lg: 'xl' }}
                                    color={useColorModeValue("gray.700", "white")}
                                    fontWeight='bold'
                                    ms={{ sm: '8px', md: '0px' }}
                                    mr={2}
                                >
                                    {user.first_name} {user.last_name}
                                </Text>
                                </Flex>
                                
                                <Text fontSize={{ sm: 'sm', md: 'md' }} color={useColorModeValue('gray.400', 'gray.300')}>
                                    {user.email}
                                </Text>
                            </Flex>
                        </Flex>
                        <Flex direction={{ base: 'column', lg: 'row' }} mt={{base : 2 ,md:0}} w={{ sm: '100%', md: '50%', lg: 'auto' }}>
                            <Button
                                onClick={()=> navigate('/profil')}
                                borderRadius='12px'
                                bg={useColorModeValue('gray.200', 'gray.700')}
                                me={{ base: 'none', lg: '20px' }}
                                leftIcon={<Icon color={useColorModeValue("gray.700", "white")} as={ImProfile} me='6px' />}>
                                <Text fontSize='sm' color={useColorModeValue("gray.700", "white")} fontWeight='bold'>
                                    {t("PROFIL")}
                                </Text>
                            </Button>
                            <Button
                                borderRadius='12px'
                                bg='transparent'
                                onClick={()=> navigate('/modifier-profil')}
                                me={{ base: 'none', lg: '20px' }}
                                leftIcon={<Icon color={useColorModeValue("gray.700", "white")} as={MdSettings} me='6px' />}>
                                <Text fontSize='sm' color={useColorModeValue("gray.700", "white")} fontWeight='bold'>
                                    {t("PARAMÈTRE")}
                                </Text>
                            </Button>
                            <Button
                                borderRadius='12px'
                                bg='transparent'
                                onClick={() => navigate('/securite-de-compte')}
                                me={{ base: 'none', lg: '20px' }}
                                leftIcon={<Icon color={useColorModeValue("gray.700", "white")} as={MdSettings} me='6px' />}>
                                <Text fontSize='sm' color={useColorModeValue("gray.700", "white")} fontWeight='bold'>
                                {t("SÉCURITÉ DE COMPTE")}
                                </Text>
                            </Button>
                            {/* <Button
                                borderRadius='12px'
                                bg='transparent'

                                leftIcon={<Icon color={useColorModeValue("gray.700", "white")} as={FaCube} me='6px' />}>
                                <Text fontSize='sm' color={useColorModeValue("gray.700", "white")} fontWeight='bold'>
                                    ELSE
                                </Text>
                            </Button> */}
                        </Flex>
                    </Flex>
                </Flex>
                <Flex justify={'center'} w={"100%"} px={5}>

                    <Card
                    w={{base:"100%" , lg:"80%"}}
                    bg={useColorModeValue("gray.100", "gray.700")}
                    display={'flex'}
                    justify={'center'}
                    p='16px'
                    boxShadow={"xl"}
                        
                    >
                        <CardHeader p='5px 5px' mb='2px'>
                            <Text fontSize='lg' color={useColorModeValue("gray.700", "white")} fontWeight='bold'>
                                {t("Informations de profil")}
                            </Text>
                        </CardHeader>
                        <CardBody px='5px'>
                            <Flex direction='column'>

                                {/* <Separator mb='30px' /> */}
                                {/* <Flex align='center' mb='14px'>
                                    <Flex w={"50%"}>
                                        <Text letterSpacing={1} w={{ base: "50%", sm: "40%", lg: "20%" }} fontSize='md' color={'gray.500'} me='10px'>
                                            Nom  :{' '}
                                        </Text>
                                        <Text fontSize='md' color={useColorModeValue("gray.700", "white")} fontWeight='400'>
                                            {user.last_name}
                                        </Text>
                                    </Flex>
                                    <Flex w={"50%"}>
                                        <Text letterSpacing={1} w={{ base: "50%", sm: "40%", lg: "20%" }} fontSize='md' color={'gray.500'} me='10px'>
                                            Prenom :{' '}
                                        </Text>
                                        <Text fontSize='md' color={useColorModeValue("gray.700", "white")} fontWeight='400'>
                                            {user.first_name}
                                        </Text>
                                    </Flex>

                                </Flex> */}
                                <Flex  mb='14px' flexDirection={{base: "column",md:"row"}}>
                                    <Text letterSpacing={1} w={{ base: "40%", sm: "40%", lg: "30%" }} fontSize={{ sm: 'sm', md: 'md' }}  color={'gray.500'} me='10px'>
                                        {t("Nom complet")} {' '}
                                    </Text>
                                    <Text  fontSize={{ sm: 'sm', md: 'md' }}  color={useColorModeValue("gray.700", "white")} fontWeight='400'>
                                     : &nbsp; {user.first_name} {user.last_name}
                                    </Text>
                                </Flex>
                                <Flex  mb='14px' flexDirection={{base: "column",md:"row"}}>
                                    <Text letterSpacing={1} w={{ base: "40%", sm: "40%", lg: "30%" }} fontSize={{ sm: 'sm', md: 'md' }}  color={'gray.500'} me='10px'>
                                        {t("Adresse Email")} {' '} 
                                    </Text>
                                    <Text  fontSize={{ sm: 'sm', md: 'md' }}  color={useColorModeValue("gray.700", "white")} fontWeight='400'>
                                     : &nbsp; {user.email}
                                    </Text>
                                </Flex>
                                <Flex  mb='14px' flexDirection={{base: "column",md:"row"}}>
                                    <Text letterSpacing={1} w={{ base: "40%", sm: "40%", lg: "30%" }} fontSize={{ sm: 'sm', md: 'md' }}  color={'gray.500'} me='10px'>
                                        {t("Telephone")} {' '}
                                    </Text>
                                    <Text fontSize={{ sm: 'sm', md: 'md' }}  color={useColorModeValue("gray.700", "white")} fontWeight='400'>
                                    : &nbsp; {user.tel ? user.tel  : <span style={{ color:'#8080807a'}}> {t("Téléphone non disponibles")}.</span>}
                                    </Text>
                                </Flex>
                                
                                
                            </Flex>
                        </CardBody>
                    </Card>
                   
                </Flex>
            </Flex>
        </Box>

    )
}

export default Profile